import {
  type LookalikeFormSegment,
  lookalikeSpecificCategory,
} from '../../../../../../../modules/audiences/AudienceForm/types.ts';

export type GroupedLookalikeDefinition = {
  similaritySegment?: LookalikeFormSegment;
  seedSegment?: LookalikeFormSegment;
};

export const groupLookalikeDefinitions = (
  segments: LookalikeFormSegment[] = []
): Map<string, GroupedLookalikeDefinition> => {
  const groups = new Map<string, GroupedLookalikeDefinition>();

  segments.forEach(segment => {
    const definitionId = segment.lookalike_definition_id;

    if (!definitionId) return;

    if (!groups.has(definitionId)) {
      groups.set(definitionId, {});
    }

    if (segment.sub_category === lookalikeSpecificCategory.Similarity) {
      groups.set(definitionId, { ...groups.get(definitionId), similaritySegment: segment });
    } else if (segment.sub_category === lookalikeSpecificCategory.SeedAggregate) {
      groups.set(definitionId, { ...groups.get(definitionId), seedSegment: segment });
    }
  });

  return groups;
};
